var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsCustomesignActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.517,
    height: 11,
    viewBox: "0 0 20.517 11.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-272.269 -409.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M300.806,430.455H281.451a.727.727,0,0,0,0,1.425h19.356a.727.727,0,0,0,0-1.424Z",
    transform: "translate(-8.601 -10.538)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M286.013,419.376a.667.667,0,0,0,.423-.154,35.777,35.777,0,0,0,3.222-3.205c1.79-1.931,4.015-4.337,5.183-4.027a.368.368,0,0,1,.149.064c.164.332-.518,1.8-.81,2.425-.54,1.161-.967,2.078-.712,2.814a1.1,1.1,0,0,0,.606.667c.893.38,1.865-.349,2.894-1.122.784-.59,1.856-1.4,2.3-1.089.155.108.2.581.243.961.066.642.157,1.521.882,1.886.76.382,1.879.124,5.117-2.34a.842.842,0,0,0,.184-1.1.671.671,0,0,0-.991-.2c-2.639,2.008-3.461,2.207-3.681,2.207h0a4.168,4.168,0,0,1-.1-.631,2.724,2.724,0,0,0-.9-2.118c-1.231-.855-2.625.194-3.856,1.12a11.189,11.189,0,0,1-1.235.845c.133-.355.351-.826.515-1.179.628-1.35,1.278-2.746.839-3.8a1.571,1.571,0,0,0-1.114-.939c-1.927-.513-4.153,1.892-6.505,4.431a34.709,34.709,0,0,1-3.075,3.067.838.838,0,0,0-.253.881.723.723,0,0,0,.677.541Z",
    transform: "translate(-13.031 -0.866)",
    fill: "#1450ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsCustomesignActiveIcon);
export default __webpack_public_path__ + "static/media/settings-customesign-active-icon.83b5106b22ce02eae78a893749934748.svg";
export { ForwardRef as ReactComponent };